<button class="close float-right" mat-dialog-close>&times;</button>
<h2 mat-dialog-title>Carteira</h2>
<mat-dialog-content class="mat-typography">

    <form [formGroup]="this.form">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h5><strong>Nome:</strong></h5>
                    <p>{{carteira.nome.toUpperCase()}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-10">
                    <h5><strong>Nome completo:</strong></h5>
                    <p>{{carteira.nomeCompleto}}</p>
                </div>
                <div class="col-2">
                    <h5><strong>CNPJ:</strong></h5>
                    <p>{{formatCnpj(carteira.cnpj)}}</p>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col">
                    <h5><strong>Administrador:</strong></h5>
                    <p>{{carteira.admin}}</p>
                </div>
                <div class="col">
                    <h5><strong>Gestor:</strong></h5>
                    <span>{{carteira.gestor}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <h5><strong>Grupo econômico:</strong></h5>
                    <p>{{carteira.grupo}}</p>
                </div>
            </div>
            <hr>
            <div class="row" *ngIf="readonly">
                <div class="col">
                    <h5><strong>Processamento automático:</strong></h5>
                    <p>{{carteira.auto ? 'Sim' : 'Não'}}</p>
                </div>
            </div>
            <div class="card mt-3" *ngIf="!readonly">
                <div class="card-header">
                    <h4>Processamento enquadramento automático <span
                        matTooltip="Automático - a realização do processamento do enquadramento logo após a conclusãp do processamento da carteira no Sistema de Ativos.
                Independente - a realização manual do processamento do enquadramento (conforme agendamento prévio ou via tela)."><i
                        class="fa fa-info-circle"></i></span></h4>
                </div>
                <div class="card-body">
                    <mat-slide-toggle formControlName="auto" color="primary">Sim</mat-slide-toggle>
                </div>
            </div>
        </div>
    </form>

</mat-dialog-content>
<mat-dialog-actions *ngIf="!readonly">
    <div class="container-fluid">
        <div class="row">
            <div class="col-10">
            </div>
            <div class="col-2 pl-5">
                <button mat-raised-button color="primary" [disabled]="form.pristine" mat-dialog-close type="button" (click)="save()">
                    Gravar
                </button>
            </div>
        </div>
    </div>
</mat-dialog-actions>
